// extracted by mini-css-extract-plugin
export var appStoreButtons = "PlusWelcome-module__appStoreButtons___ywXBU";
export var bottomRowContainer = "PlusWelcome-module__bottomRowContainer___O2Cxy";
export var btn = "PlusWelcome-module__btn___FPlUG";
export var colContainer = "PlusWelcome-module__colContainer___GCvr6";
export var content = "PlusWelcome-module__content___ohTTr";
export var desktopBadge = "PlusWelcome-module__desktopBadge___Wzw_k";
export var heading = "PlusWelcome-module__heading___fG2LG";
export var headingContainer = "PlusWelcome-module__headingContainer___UC99p";
export var imgContainer = "PlusWelcome-module__imgContainer___tyeDq";
export var mobile = "PlusWelcome-module__mobile___VjOkg";
export var mobileBadge = "PlusWelcome-module__mobileBadge___UQfqa";
export var qrCodeContainer = "PlusWelcome-module__qrCodeContainer___KV97G";
export var sideImage = "PlusWelcome-module__sideImage___UMfbT";
export var subheading = "PlusWelcome-module__subheading___dRnDd";
export var welcome = "PlusWelcome-module__welcome___lKo9r";